import { ProfileIcon, SortDirection } from "@ygtechnologies/bygr-frontend-component-library";
import React, { useState } from "react";
import { getProfiles } from "services/profiles";
import { BygrProfile, PaginationResult } from "types";
import { useAsyncStateWithIsLoading } from "utils/hooks";
import { searchByFields } from "utils/search";
import theme from "./LinkProjectModal.module.scss"

interface ProjectLinkedProjectProps {
    onSelect(profile: BygrProfile): void;
    searchText: string;
}

const ProjectLinkedProject: React.FC<ProjectLinkedProjectProps> = ({onSelect, searchText}) => {
    const [pageNumber, ] = useState(0);
    const [pageSize, ] = useState(10000); // TODO: Implement pagination properly or use unpaginated endpoint?
    const [data, , , isLoading] = useAsyncStateWithIsLoading<PaginationResult<BygrProfile> | null>(() => {
        return getProfiles(
            {  
                pageNumber, 
                pageSize, 
                searchText, 
                sortBy: "name", 
                sortDirection: SortDirection.Ascending 
            });
        }, [searchText], null
    );

    // TODO: Filter out the profile of current project from the list?

    if (!data) {
        return (isLoading ? <div>Loading...</div> : <div>No profiles found</div>);
    }

    return (
        <div className={theme.wrapper}>
            {searchByFields(data.items, searchText, ['name'])?.map((profile) => (
                <div className={theme.select} key={profile.id}>
                    <button className={theme.selectButton} onClick={() => onSelect(profile)}>
                        <ProfileIcon profileIconUrl="" sizeInPx={36} className={theme.companyImg} />
                        <div className={theme.info}>
                            <div>{profile.name}</div>
                        </div>
                    </button>
                    <div className={theme.separator} />
                </div>  
            ))}
        </div>
    );
};

export default ProjectLinkedProject;